<template>
	<div ref="component">
		<slot
			:scrolled="scrolled"
			:canScroll="canScroll"
			:scrolledTop="scrolledTop"
			:scrolledBottom="scrolledBottom"
		></slot>
	</div>
</template>

<script>
import GenericMixin from '@/mixins/GenericVueMixin'
export default {
	mixins: [
		GenericMixin
	],
	props: {
		selector: {
			type: String,
			default: "[data-scrollcontainer]"
		},
		upSelector: {
			type: String,
			default: "[data-scrollcontainer-up]"
		},
		downSelector: {
			type: String,
			default: "[data-scrollcontainer-down]"
		},
		itemSelector: {
			type: String,
			default: "[data-scrollcontainer-item]"
		},
		toWatch: {
			default: null
		},
	},
	watch: {
		toWatch(newValue, oldValue) {
			this.$nextTick(() => {
				this.onUpdateScroll();
			});
		}
	},
	data() {
		return {
			canScroll: false,
			scrolledTop: false,
			scrolledBottom: false,
			scrollIncrement: 120,
			scrolled: false,
		}
	},
	methods: {
		onUpdateScroll() {
			let factor
			const comp = this.boundElement

			if (this.isMobile()) {
				factor = Math.round(comp.scrollLeft) / (comp.scrollWidth - comp.clientWidth)
			}
			else {
				factor = Math.round(comp.scrollTop) / (comp.scrollHeight - comp.clientHeight)
			}

			this.canScroll = comp.clientHeight < comp.scrollHeight || comp.clientWidth < comp.scrollWidth
			this.scrolledTop = factor === 0
			this.scrolledBottom = factor === 1
		},
	},
	mounted() {
		this.boundScroll = this.onUpdateScroll.bind(this)
		this.boundElement = this.$refs.component.querySelector(this.selector)
		this.boundUpElement = this.$refs.component.querySelector(this.upSelector)
		this.boundDownElement = this.$refs.component.querySelector(this.downSelector)
		window.addEventListener('resize', this.boundScroll)
		this.boundElement.addEventListener('scroll', e => {
			this.scrolled = true;
		}, {once: true});
		this.boundElement.addEventListener("scroll", this.boundScroll)

		this.boundUpElement.addEventListener('mouseenter', e => {
			let up = () => {
				this.boundElement.scrollTop -= 3;
				this.scrollUpFrame = requestAnimationFrame(up);
			};
			up();
		});

		this.boundUpElement.addEventListener('mouseleave', e => {
			cancelAnimationFrame(this.scrollUpFrame);
		});

		this.boundDownElement.addEventListener('mouseenter', e => {
			let down = () => {
				this.boundElement.scrollTop += 3;
				this.scrollDownFrame = requestAnimationFrame(down);
			};
			down();
		});

		this.boundDownElement.addEventListener('mouseleave', e => {
			cancelAnimationFrame(this.scrollDownFrame);
		});

		this.$nextTick(() => {
			this.onUpdateScroll()
		})
	},
	destroyed() {
		this.boundElement.removeEventListener("scroll", this.boundScroll)
		window.removeEventListener('resize', this.boundScroll)
	}
}
</script>

<style>

</style>